import React from "react";
import { CookieCategory } from "./CookieCategory";
import { ConsentCategory, ConsentService, ConsentStaticTexts } from "./CookieConsentModal";

interface ExpandedViewProps {
    onCollapse: () => void;
    texts: ConsentStaticTexts;
    consents: ConsentService[];
    categories: ConsentCategory[];
    serviceConsents: Record<string, boolean>;
    onConsentChange: (serviceId: string, isEnabled: boolean) => void;
    onAcceptEssential: () => void;
    onSaveChoices: () => void;
    onAcceptAll: () => void;
}

export const ExpandedView: React.FC<ExpandedViewProps> = ({
    onCollapse,
    texts,
    consents,
    categories,
    serviceConsents,
    onConsentChange,
    onAcceptEssential,
    onSaveChoices,
    onAcceptAll
}) => {
    return (
        <div className="tq-modal un-ds-modal tq-modal-visible un-ds-modal-generic un-modal-cookies">
            <div className="tq-modal-overlay" role="dialog" aria-modal="true"></div>
            <div className="tq-modal-container tq-modal-l">
                <div className="tq-modal-header">
                    <p className="tq-main-color un-ds-heading-3 tq-text-center">
                        {texts["personalize-title"]}
                    </p>
                    <button className="tq-button un-ds-button un-modal-close" onClick={onCollapse}>
                        <i className="tq-icon-close"></i>
                    </button>
                </div>
                <div className="tq-modal-scroll">
                    <div className="tq-modal-content">
                        <p>{texts["main-description"]}</p>
                        <p dangerouslySetInnerHTML={{ __html: texts["reference-link"] }}></p>

                        <div className="un-cookies-section">
                            {categories.map(category => (
                                <CookieCategory
                                    key={category.code}
                                    title={category.title}
                                    description={category.description}
                                    services={consents.filter(
                                        service => service.category === category.code
                                    )}
                                    serviceConsents={serviceConsents}
                                    onConsentChange={onConsentChange}
                                    allServicesText={"Préférences pour tous les services"} // This text is missing from the provided JSON
                                    showMoreText={texts["show-more-button"]}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                <div className="tq-modal-footer un-ds-action-section-center">
                    <button
                        onClick={onAcceptEssential}
                        className="tq-button un-ds-button  un-ds-button-outline un-ds-component-sm"
                    >
                        <span className="tq-text-node">
                            {texts["personalize-accept-essential-button"]?.toUpperCase() || ""}
                        </span>
                    </button>
                    <button
                        onClick={onSaveChoices}
                        className="tq-button un-ds-button un-ds-button-outline un-ds-component-sm"
                    >
                        <span className="tq-text-node">
                            {texts["save-choices-button"]?.toUpperCase() || ""}
                        </span>
                    </button>
                    <button
                        onClick={onAcceptAll}
                        className="tq-button un-ds-button un-ds-button-solid un-ds-component-sm"
                    >
                        <span className="tq-text-node">
                            {texts["accept-all-button"]?.toUpperCase() || ""}
                        </span>
                    </button>
                </div>
            </div>
        </div>
    );
};
